export default __webpack_public_path__ + "static/media/img-speed-on-1.aba7df55.svg";